export default {"src":"/_next/static/media/mascot-eyes-down.373813de.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};